module.exports = __webpack_public_path__ + "lp/img/question_icon-darkgray.3473dda7.svg";